import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { DATE_FORMAT_MMMM_D_YYYY } from 'constants/formats';
import { MONTHS_IN_YEAR } from 'constants/times';
import dayjs from 'dayjs';

import { SUBSCRIPTION_STATUS } from 'interfaces/subscriptions';

import { ILabelProps } from './types';

import styles from './SubscriptionHorizontalCard.module.scss';

export const MonthlyLabel: FC<ILabelProps> = ({
  monthlyPayment,
  isCurrentFrequency,
  endDate,
  isCurrentPlan,
  subscriptionStatus,
}) => {
  const { t, i18n } = useTranslation();
  dayjs.locale(i18n.language);
  const formattedDate = dayjs(endDate * 1000).format(DATE_FORMAT_MMMM_D_YYYY);

  return (
    <>
      <Box component="p" className={styles.price}>
        {t('pricePerMonth', { price: monthlyPayment })}
      </Box>
      <Typography variant="subtitle2" component="p" className={styles.additionalInfo}>
        {isCurrentFrequency && isCurrentPlan && subscriptionStatus === SUBSCRIPTION_STATUS.ACTIVE
          ? t('nextBilling', { date: formattedDate })
          : t('billedMonthly')}
      </Typography>
    </>
  );
};

export const AnnualLabel: FC<ILabelProps> = ({
  monthlyPayment,
  endDate,
  isCurrentPlan,
  isCurrentFrequency,
  subscriptionStatus,
}) => {
  const { t, i18n } = useTranslation();
  dayjs.locale(i18n.language);
  const formattedDate = dayjs(endDate * 1000).format(DATE_FORMAT_MMMM_D_YYYY);

  return (
    <>
      <Box component="p" className={styles.price}>
        {t('pricePerMonth', { price: monthlyPayment })}
      </Box>
      <Typography variant="subtitle2" component="p" className={styles.additionalInfo}>
        {t('billedAnnually', { price: monthlyPayment * MONTHS_IN_YEAR })}
      </Typography>
      {isCurrentPlan && subscriptionStatus === SUBSCRIPTION_STATUS.ACTIVE && (
        <Typography variant="subtitle2" component="p" className={styles.additionalInfo}>
          {isCurrentPlan && isCurrentFrequency
            ? t('nextBilling', { date: formattedDate })
            : t('savePercent', { percent: 30 })}
        </Typography>
      )}
    </>
  );
};
